import { Box, CircularProgress, type CircularProgressProps } from '@mui/material';

interface LoadingSpinnerProps extends CircularProgressProps {
  fullScreen?: boolean;
}

export const LoadingSpinner = ({ fullScreen = false, ...props }: LoadingSpinnerProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: fullScreen ? '100vh' : '200px',
    }}
  >
    <CircularProgress {...props} />
  </Box>
);
